export default __webpack_public_path__ + "static/media/021-coin.de92a454.png";